/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactPerson } from './ContactPerson';
import {
    ContactPersonFromJSON,
    ContactPersonFromJSONTyped,
    ContactPersonToJSON,
} from './ContactPerson';

/**
 * 
 * @export
 * @interface LegalEntityDetails
 */
export interface LegalEntityDetails {
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    entityName?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    registrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    entityType?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    mobileNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    taxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    ficaStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    physicalAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    contactName?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    tradingName?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    dateOfRegistration?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    countryOfIncorporation?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    countryOfOperation?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    workTelephoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    postalAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDetails
     */
    sector?: string;
    /**
     * 
     * @type {ContactPerson}
     * @memberof LegalEntityDetails
     */
    contactPerson?: ContactPerson;
}

/**
 * Check if a given object implements the LegalEntityDetails interface.
 */
export function instanceOfLegalEntityDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LegalEntityDetailsFromJSON(json: any): LegalEntityDetails {
    return LegalEntityDetailsFromJSONTyped(json, false);
}

export function LegalEntityDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalEntityDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityName': !exists(json, 'EntityName') ? undefined : json['EntityName'],
        'registrationNumber': !exists(json, 'RegistrationNumber') ? undefined : json['RegistrationNumber'],
        'entityType': !exists(json, 'EntityType') ? undefined : json['EntityType'],
        'email': !exists(json, 'Email') ? undefined : json['Email'],
        'mobileNumber': !exists(json, 'MobileNumber') ? undefined : json['MobileNumber'],
        'taxNumber': !exists(json, 'TaxNumber') ? undefined : json['TaxNumber'],
        'ficaStatus': !exists(json, 'FicaStatus') ? undefined : json['FicaStatus'],
        'physicalAddress': !exists(json, 'PhysicalAddress') ? undefined : json['PhysicalAddress'],
        'country': !exists(json, 'Country') ? undefined : json['Country'],
        'contactName': !exists(json, 'ContactName') ? undefined : json['ContactName'],
        'tradingName': !exists(json, 'TradingName') ? undefined : json['TradingName'],
        'dateOfRegistration': !exists(json, 'DateOfRegistration') ? undefined : json['DateOfRegistration'],
        'countryOfIncorporation': !exists(json, 'CountryOfIncorporation') ? undefined : json['CountryOfIncorporation'],
        'countryOfOperation': !exists(json, 'CountryOfOperation') ? undefined : json['CountryOfOperation'],
        'workTelephoneNumber': !exists(json, 'WorkTelephoneNumber') ? undefined : json['WorkTelephoneNumber'],
        'postalAddress': !exists(json, 'PostalAddress') ? undefined : json['PostalAddress'],
        'sector': !exists(json, 'Sector') ? undefined : json['Sector'],
        'contactPerson': !exists(json, 'ContactPerson') ? undefined : ContactPersonFromJSON(json['ContactPerson']),
    };
}

export function LegalEntityDetailsToJSON(value?: LegalEntityDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'EntityName': value.entityName,
        'RegistrationNumber': value.registrationNumber,
        'EntityType': value.entityType,
        'Email': value.email,
        'MobileNumber': value.mobileNumber,
        'TaxNumber': value.taxNumber,
        'FicaStatus': value.ficaStatus,
        'PhysicalAddress': value.physicalAddress,
        'Country': value.country,
        'ContactName': value.contactName,
        'TradingName': value.tradingName,
        'DateOfRegistration': value.dateOfRegistration,
        'CountryOfIncorporation': value.countryOfIncorporation,
        'CountryOfOperation': value.countryOfOperation,
        'WorkTelephoneNumber': value.workTelephoneNumber,
        'PostalAddress': value.postalAddress,
        'Sector': value.sector,
        'ContactPerson': ContactPersonToJSON(value.contactPerson),
    };
}

